export default {
    "service.mpm.push.device.in.abnormal.status":"设备处于异常状态",
    "server.mdm.device.already.activated.not.modify.imei":"设备已激活，无法更新IMEI",
    "server.imei.cannot.be.empty":"IMEI不能为空！",
    "server.mfm.ui.customization.name.exists":"名称已存在",
    "server.mfm.upload.file.empty":"上传文件为空！",
    "server.mfm.application.version.name.exists":"应用程序版本名称已存在",
    "server.mfm.application.already.signed":"应用程序已签名！",
    "server.mfm.file.sf.bl.md5.invalid":"请上传包含SF、BL或MD5的压缩文件！",
    "server.mfm.application.upload.failed":"上传{param}失败！",
    "server.mfm.file.md5.invalid":"无效的MD5或未添加MD5",
    "server.mfm.picture.resolution.not.match":"上传失败，压缩包中的图片分辨率不匹配！",
    "server.mfm.picture.format.not.match":"上传失败，压缩包中的图片格式不匹配！",
    "server.mfm.boot.animatio.upload.failed":"上传失败，zip文件内容不符合开机动画图片规则！",
    "server.mfm.resolution.and.model.version.not.match":"上传失败，文件的分辨率和格式与型号版本不匹配！",
    "server.mfm.model.version.format.value":"型号版本未设置支持的文件格式",
    "server.mfm.application.version.exists":"版本{param}已存在于{applicationVersionName}中",
    "server.mfm.application.package.name.not.match":"应用程序的软件包名不匹配",
    "server.mfm.customer.without.signature.application.signed.fail":"客户未签名，应用程序签名失败",
    "server.mfm.file.upload.failed":"上传文件失败",
    "server.mfm.parameter.validation.failed":"参数验证失败！",
    "server.mfm.certificate_format.failed":"请上传pk8文件",
    "server.mfm.certificate_pem_format.failed":"请上传pem文件",
    "server.mfm.tlsCertificate.name.format.invalid":"名称只能输入字母、数字、下划线、点和空格！",
    "server.mfm.tlsCertificate.name.length.invalid":"名称不能为空，长度不能超过50个字符！",
    "server.mfm.tlsCertificate.file.suffix.invalid":"仅允许文件使用zip格式！",
    "server.mfm.firmware.format.not.match":"请检查固件格式！",

    "server.common.name.exists":"名称已使用！",
    "server.common.invalid.permission":"普通用户不能编辑公共数据",
    "server.commom.classification.inconsistent.with.user":"合作伙伴信息应与当前用户保持一致",
    "server.common.invalid.id":"更新时ID无效",
    "server.common.id.exists":"在创建时Id已存在",
    "server.common.error":"内部服务器错误",
    "server.mam.deleting.with.application.version.error":"应用程序版本与此应用程序相关联，请先删除它",
    "server.common.delete.public.file.error":"无法删除公共文件",
    "server.mam.application.version.used.terminal.profiles":"应用程序版本由终端配置文件使用，终端配置文件: {param}",
    "server.mcm.partner.not.enable.remote.control": "合作伙伴未开启远程控制，无法开启无人值守模式",
    "server.mcm.merchant.attached":"商户与此客户相关联，请先删除商户",
    "server.mcm.store.attached":"商店与此商户相关联，请先删除商店",
    "server.mcm.customer.attached":"客户与此合作伙伴相关联，请先删除客户",
    "server.mcm.sub.partner.attached":"存在子合作伙伴，无法执行此过程",
    "server.mcm.devices.attached.with.store":"设备与此商店相关联，请先取消绑定设备",
    "server.mcm.devices.attached.with.partner":"设备与此合作伙伴相关联，请先解除对设备的绑定",
    "server.mcm.devices.attached.with.customer":"设备与此客户相关联，请先解除对设备的绑定",
    "server.mcm.devices.attached.with.merchant":"设备与此商户相关联，请先解除对设备的绑定",
    "server.mcm.user.attached.with.partner":"用户与此合作伙伴相关联",
    "server.mcm.application.attached.with.partner":"应用程序与此合作伙伴相关联",
    "server.mcm.application.version.attached.with.partner":"应用程序版本与此合作伙伴相关联",
    "server.mcm.firmware.attached.with.partner":"固件与此合作伙伴相关联",
    "server.mcm.firmware.version.attached.with.partner":"固件版本与此合作伙伴相关联",
    "server.mcm.group.attached.with.partner":"组与合作伙伴相关联，请先删除组",
    "server.mcm.geo.fencing.attached.with.partner":"地理围栏与此合作伙伴相关联",
    "server.mcm.certificate.attached.with.partner":"证书与此合作伙伴相关联",
    "server.mcm.folder.attached.with.partner":"文件夹与此合作伙伴相关联",
    "server.mcm.file.attached.with.partner":"文件与此合作伙伴相关联",
    "server.mcm.advertisement.attached.with.partner":"广告计划与此合作伙伴相关联",
    "server.mcm.advertisement.version.attached.with.partner":"广告与此合作伙伴相关联",
    "server.mcm.ui.settings.attached.with.partner":"UI设置与此合作伙伴相关联",
    "server.mcm.templates.attached.with.partner":"交易参数与此合作伙伴相关联",
    "server.mcm.templates.version.attached.with.partner":"交易参数版本与此合作伙伴相关联",
    "server.mcm.operation.attached":"该partner'告警'功能已被引用，请完成对应功能后，再删除partner数据",
    "server.mdm.delete.device.error":"设备已激活，无法删除！",
    "server.mdm.sn.exists":"序列号为{param}的设备已存在",
    "server.mdm.imei.exists":"IMEI为{param}的设备已存在",
    "server.mdm.tid.exists":"TID已存在",
    "server.mdm.devices.no.customer":"组内的设备尚未绑定到客户级别，请先进行绑定！",
    "server.mdm.firmware.attached":"固件版本与此固件相关联，请先删除固件版本",
    "server.mdm.firmware.used.terminal.profiles": "固件被终端配置文件使用，终端配置文件: {param}",
    "server.mdm.firmware.version.used.terminal.profiles": "固件版本被终端配置文件使用，终端配置文件: {param}",
    "server.mdm.devices.attached":"设备与此组相关联，请先解除对设备的绑定",
    "server.mdm.device.not.exist":"设备不存在！",
    "server.mdm.device.not.activated":"设备未激活！",
    "server.mdm.log.capture.unfinshed":"该设备有未完成的日志抓取任务！",
    "server.mdm.device.group.attached":"所选设备包括绑定到组的设备，请先将设备与组解除关联",
    "server.mdm.device.group.bind.unbind":"您将要绑定的分类与设备的合作伙伴不相关，请取消当前合作伙伴的设备绑定，以便将设备绑定到其他合作伙伴/客户/商户/商店/组",
    "server.mdm.unbind.device.permissions.issue":"普通用户不允许解除当前绑定到其合作伙伴的设备",
    "server.mdm.manufacturer.attached":"型号与此厂商相关联，请先删除型号",
    "server.mdm.model.version.attached":"设备与此型号版本相关联，请先解除设备绑定",
    "server.mdm.model.attached":"型号版本与此型号相关联，请先删除型号版本",
    "server.mdm.admin.cannot.modify.group":"管理员或操作员不能修改其他合作伙伴的组！",
    "server.mdm.admin.cannot.delete.group":"管理员或操作员不能删除其他合作伙伴的组！",
    "server.mdm.enable.profile.exists":"已存在启用的终端初始化文件",
    "server.mdm.profile.name.exists":"终端初始化文件名称已存在",
    "server.mdm.profile.is.enable":"终端初始化文件已启用，无法删除！",
    "server.mfm.file.name.exists":"存在相同的文件名",
    "server.mkm.key.expired":"密钥已过期！",
    "server.mkm.key.no.activated.device":"不存在激活的设备",
    "server.mkm.hsm.no.exists":"HSM接口不可用",
    "server.mkm.kcv.keyvalue.error":"KCV值错误",
    "server.mkm.no.activated.device.in.store":"商店中不存在激活的设备",
    "server.mkm.key.delete.error":"删除失败，请检查设备主密钥",
    "server.mkm.deleting.with.model.error":"HSM品牌下有一个HSM型号，请先删除HSM型号！",
    "server.mkm.deleting.with.interface.error":"HSM型号下有一个HSM接口，请先删除HSM接口！",
    "server.mkm.same.key.index.has.been.occupied":"相同的密钥索引已被占用，请更改",
    "server.mkm.same.key.partner.keyname.duplicate":"相同合作伙伴下不允许有相同名称的密钥",
    "server.mmm.deleting.advertisement":"广告与此计划关联，请先删除广告",
    "server.mmm.deleting.folder":"文件与此文件夹关联，请先删除文件",
    "server.mpm.device.kiosk.mode":"应用程序处于霸屏模式，请先{param}上的霸屏模式",
    "server.mpm.login.as.partner":"请以普通用户身份登录以执行此功能",
    "server.mpm.device.required":"需要设备序列号才能完成此流程",
    "server.mpm.invalid.push.status":"目前处于结束状态，无法更新其他状态",
    "server.mpm.invalid.device.status":"设备已经处于执行状态，无法更新为PUSH RECEIVED状态",
    "server.mpm.push.device.activated":"设备处于异常状态，无法进行推送",
    "server.mpm.push.device.out.of.fence":"设备超过地理围栏，无法进行推送",
    "server.mrm.application.data.empty":"应用程序数据为空",
    "server.mrm.device.data.empty":"找不到匹配的数据！",
    "server.mrm.firmware.data.empty":"固件数据为空",
    "server.mrm.device.not.exists":"序列号为{param}的设备不存在",
    "server.mrm.device.not.timeline":"设备没有生命周期",
    "server.mrm.push.data.empty":"推送数据为空",
    "server.mrm.report.sql.error":"SQL语句错误，请检查！",
    "server.mtm.create.template.error":"交易参数名称已经存在",
    "server.mtm.deleting.with.transaction.version.error":"交易参数下有交易参数版本，请先删除交易参数版本！",
    "server.storm.email.exists":"邮箱已经被使用！",
    "server.storm.login.name.exists":"登录名已存在！",
    "server.storm.incorrect.password":"旧密码填写错误",
    "server.storm.activate.token.failed":"用户激活令牌失败，请联系管理员！",
    "server.storm.replace.token.failed":"用户替换令牌失败，请联系管理员！",
    "server.storm.password.policy.varification.error":"验证用户密码策略失败",
    "server.storm.password.not.same":"新密码不能与当前密码相同",
    "server.storm.password.reset.exception":"用户重置密码异常",
    "server.storm.add.history.password.failed":"用户重置密码时添加历史密码失败",
    "server.storm.login.user.failed":"用户账户为空",
    "server.storm.user.not.exist":"用户：{param} 不存在",
    "server.storm.password.policy.update.error":"更新密码策略错误",
    "server.storm.password.policy.invalid":"无效的密码策略",
    "server.storm.password.history.invalid":"无效的密码历史记录",
    "server.storm.invalid.dynamic.password":"无效的OTP，剩余错误重试次数：{param}",
    "server.storm.user.state.failed":"用户处于异常状态 [{param}]，请联系管理员！",
    "server.storm.bind.token.failed":"用户的合作伙伴未启用双因素身份验证！",
    "server.storm.pwd.less.short.len.error":"密码长度范围为{param}-32位",
    "server.storm.pwd.char.repeat.error":"密码中不允许有重复的字符",
    "server.storm.pwd.name.pwd.no.same.error":"用户名和密码不允许相同",
    "server.storm.pwd.num.and.char.error":"密码应为数字和字母的组合",
    "server.storm.pwd.least.special.with.num.char.error":"密码必须包含字母数字和至少一个特殊字符",
    "server.storm.pwd.num.and.char.or.special.error":"密码是数字和字母的组合，可以包含特殊字符",
    "server.storm.pwd.least.special.without.num.char.error":"密码至少包含一个特殊字符",
    "server.storm.pwd.num.or.char.error":"密码是随机字符串，不允许特殊字符",
    "server.storm.pwd.history.password.same.error":"密码不允许与历史密码相同",
    "server.storm.pwd.modify.frquency.error":"{param}天内允许修改密码一次，不允许再次修改",
    "server.storm.pwd.least.upper.letter.error":"密码必须包含至少一个大写字母",
    "server.storm.user.login.failed":"用户未激活或不存在，请联系管理员",
    "server.storm.user.enable.disable.themselves":"超级管理员、普通管理员、普通用户不允许启用、禁用、删除自身、重置密码、激活OTP、替换OTP或发送激活二维码",
    "server.storm.user.enable.disable.other":"超级管理员、普通管理员、普通用户不允许相互启用、禁用、删除、重置密码、激活OTP、替换OTP或发送激活二维码",
    "server.mfm.Payment.Certificates.name.exists":"TLS证书名称已经存在",
    "server.storm.user.not.bind.token":"用户未绑定令牌！",
    "server.mfm.tlsCertificate.name.exists":"TLS证书名称已经存在",
    "server.storm.otp.invalid.packet":"OTP错误：无法验证OTP，请联系管理员以同步OTP",
    "server.storm.otp.token.lost":"OTP错误：令牌已丢失，请联系管理员以解锁令牌",
    "server.storm.otp.token.logout":"OTP错误：令牌已作废，请联系管理员以更换令牌",
    "server.storm.otp.token.expired":"令牌已过期，请联系管理员以更换令牌",
    "server.storm.otp.user.temp.locked":"OTP错误：用户已被临时锁定，请联系管理员！",
    "server.storm.otp.user.long.locked":"OTP错误：用户已被永久锁定，请联系管理员！",
    "server.storm.otp.user.bind.excedd":"OTP错误：用户绑定的令牌已达到上限，请联系管理员",
    "server.storm.otp.replay":"OTP错误：OTP重复，请输入新的OTP",
    "server.storm.otp.user.token.not.bind":"OTP错误：用户与令牌之间没有绑定关系，请联系管理员",
    "service.storm.verify.otp.error":"OTP错误：验证OTP失败，请联系管理员！",
    "service.storm.link.invalid":"激活OTP失败：该链接无效",
    "server.storm.generate.qr.code.failed":"生成二维码失败，请联系管理员！",
    "server.msm.ui.settings.version.used.terminal.profiles":"终端配置文件使用的UI版本，终端配置文件: {param}",
    "server.msm.system.param.version.used.terminal.profiles":"终端配置文件使用的系统参数版本，终端配置文件: {param}",

    "server.mrm.push.event.id.is.incorrect":"推送事件ID不正确",
    "server.mdm.model.version.attached.ui":"UI版本与此型号版本相关联，请先解除UI绑定",
    "server.mdm.model.version.attached.profile":"终端初始化文件与此型号版本相关联，请先解除终端初始化文件绑定",
    "server.mdm.device.active.modification.not.allowed.sn":"设备已激活，无法修改序列号",
    "editTIDTextInformation":"无法更改TID名称，请删除记录并创建新记录",
    "server.common.name.parent.exists":"相同的合作伙伴名称不能重复",
    "server.mfm.picture.compression.mode.match":"压缩方法不正确，仅支持存储方法为zip的文件！",
    "server.mfm.application.not.support.signature":"该应用在打包时未进行签名",
    "service.storm.enable.email.exist":"存在已启用的邮箱配置",
    "server.storm.email.is.enable":"邮箱配置已启用，无法删除！",
    "server.mdm.device.already.active":"设备已处于激活状态！",
    "server.storm.email.authentication.unsuccessful":"身份验证失败，用户凭证不正确",
    "server.storm.email.starttls.required":"需要STARTTLS才能发送邮件",
    "search.key.partner":"合作伙伴",
    "server.mam.application.version.exists":"相同文件名已存在：应用程序名称是{param}",
    "server.common.name.pattern":"名称不能为空！",
    "server.mcm.enable.signature.error":"无法启用签名，未找到二级证书",
    "server.version.exists.different.partner":"存在不同合作伙伴下的数据，无法编辑",
    "server.version.exists.public.partner":"存在公共合作伙伴下的数据，无法编辑",

    "server.mam.application.version.name.exists":"应用程序版本名称已被使用",
    "server.mmm.message.name.already.used":"消息名称已使用",
    "server.mkm.hsm.brand.name.already.used":"Hsm品牌名称已被使用",
    "server.mkm.hsm.model.name.already.used":"Hsm模型名称已被使用",
    "server.mkm.hsm.interface.name.already.used":"Hsm接口名称已被使用",
    "server.mtham.device.policy.already.used":"配置已被使用 - {name}",
    "server.mtham.device.policy.not.allow.delete":"配置存在历史记录，不允许删除",
    "server.common.mid.exists":"MID已经被使用！",
    "server.mcm.payment.certificates.attached.with.partner":"支付证书与此合作伙伴关联",
    "server.mcm.payment.certificates.attached.with.customer":"支付证书与此客户关联",
    "server.mcm.hsm.interface.attached":"HSM接口与此合作伙伴相关联",
    "server.mcm.key.attached":"密钥与此合作伙伴相关联",
    "server.common.version.exists.different.partner":"存在不同合作伙伴下的数据，无法编辑",
    "server.common.version.exists.different.customer": "存在不同客户下的数据，无法编辑",

    "server.common.name.format.mismatch":"名称格式不匹配，长度：1-50；格式：字母、数字、下划线、点和空格，不能以空格开头或结尾，字母之间只允许单个空格",
    "server.common.name.keywords.mismatch": "名称格式不匹配,名称不能等于 'ROLE_ADMIN'、'ROLE_OPERATOR'、'ROLE_PARTNER' 或 'ROLE_USER' 中的任何一个。",
    "set.ad.planner":"设置广告计划",
    "set.message":"设置消息",
    "server.mpm.push.device.in.abnormal.status":"设备处于异常状态",
    "server.mcm.not.allowed.set.itself.as.the.parent.partner":"不允许将自身设置为父合作伙伴",
    "server.mcm.not.allowed.set.child.partner.as.the.parent.partner":"不允许将当前合作伙伴的子合作伙伴设置为父合作伙伴",
    "server.mam.application.version.attached":"应用程序版本与此应用程序相关联，请先删除应用程序版本",
    "server.device.cannot.modify.model.version":"设备不能修改型号版本",
    "server.group.not.devices":"所选组中不存在设备，请不要解除绑定",
    "server.common.version.exists.public.partner":"存在公共合作伙伴下的版本，无法编辑",
    "server.common.data.not.belong.to.user":"已删除的数据不属于当前用户，请检查并修改它",
    "server.mfm.boot.picture.file.upload.failed":"文件不属于png格式",
    "server.mfm.file.md5.same.in.partner":"{param}中的同一伙伴下存在相同的文件",
    "server.mfm.file.md5.same.in.public": "{param}中的公共文件下存在相同的文件",
    "server.mcam.application.certification.name.exists":"应用程序证书名称已经存在",
    "server.mpm.devices.not.online":"设备离线，无法发送消息",
    "server.details.data.to.long":"回复消息太长，请整理一下",
    "server.content.not.json":"内容不是JSON格式",
    "server.key.attached.master.key":"主密钥与该密钥相关联，请先删除主密钥",
    "server.json.content.error":"JSON内容不正确",
    "server.mam.application.version.code.exists":"版本代码{param}已存在于{applicationVersionName}",
    "server.mam.application.file.exists":"相同文件存在！",
    "server.mdm.device.not.associated.model.version":"合作伙伴下的设备是关联的二级型号版本，请检查并修改",
    "server.mdm.log.capture.type.incorrect":"日志抓取类型不正确",
    "server.mpm.signature.file.generation.failed":"签名文件生成失败！",
    "server.mpm.differential.file.generation.failed":"差分文件生成失败！",
    "server.mcm.parent.partner.cannot.be.changed":"无法更改父合作伙伴，请检查并修改",
    "server.key.name.already.exists":"密钥名称已存在",
    "server.mdm.firmware.not.exists":"固件不存在，请检查并修改它",
    "server.msm.wallpaper.or.boot.picture.support.png.bmp.jpg.jpeg.tiff.file":"壁纸或开机第一帧支持png、bmp、jpg、jpeg、tiff格式文件",
    "server.mdm.model.version.attached.application.version":"应用程序版本与该型号版本相关联，请先解绑应用程序版本",
    "server.mdm.model.version.attached.firmware.version":"固件版本与该型号版本相关联，请先解绑固件版本",
    "server.mdm.model.version.attached.advertisement": "广告版本与该型号版本相关联，请先解绑广告",
    "server.mmm.advertisement.use.cannot.be.delete": "该文件已被广告功能使用，不允许删除！",
    "server.mmm.advertisement.not.exists": "广告不存在，请检查并修改！",
    "server.mdm.only.admin.allowed.delete.activated.device": "已激活的设备只允许admin删除",
    "server.storm.role.not.delete": "该角色为用户所使用，请先解绑关系，再尝试删除",
    "server.login.format.mismatch": "登录格式不匹配或长度不能大于50，请检查并修改！",
    "server.msm.system.param.is.required": "系统参数不能为空,请检查并修改它",
    "server.common.name.is.required": "名称是必项填, 不能为空！",

    "server.alert.group.name.already.used" : "报警组名称已存在",
    "server.alert.group.not.belong.user": "报警组不属于当前用户",
    "server.mrm.alert.men.data.empty": "报警联系人数据为空",
    "server.alert.men.name.already.used": "报警人员的名字已经存在",
    "server.alert.men.not.belong.user": "报警人不属于当前用户",
    "server.alert.policy.name.already.used": "报警策略名称已存在",
    "server.alert.policy.not.belong.user": "报警策略不属于当前用户",
    "server.alert.rule.not.exist": "报警规则不存在",
    "server.alert.rule.id.is.required": "报警规则id是必填项",
    "server.alert.rule.name.already.used": "报警规则名称已存在",
    "server.alert.rule.already.used":"报警规则已存在",
    "server.user.not.permission.to.access": " 用户无权访问partnerId下的数据",
    "server.merchant.can.only.have.one.template": "每个商户只能有一个提醒模板",
    "server.alert.template.not.belong.use": "报警模板不属于当前用户",
    "server.mrm.alert.synchronize.device.events": "同步设备事件",
    "server.mrm.alert.start.time.greater.than.end.time": "开始时间大于结束时间",
    "server.alert.setting.name.already.used": "报警设置名称已存在",
    "server.alert.setting.not.belong.user": "报警设置不属于当前用户",
    "server.alert.log.state.error": "报警日志状态错误",
    "server.alert.log.not.belong.user": "报警日志不属于当前用户",
    "server.prohibited.operation.has.turned.off": "禁用操作已关闭",
    "server.policy.referenced.cannot.deleted": "报警策略已经被引用，不能删除",
    "server.men.referenced.cannot.deleted":"报警联系人已经被引用，不能删除",
    "server.group.referenced.cannot.deleted": "报警联系人组已经被引用，不能删除",
    "server.alert.men.email.already.used": "该邮件已存在",
    "server.commom.file.must.be.xlsx": "该文件应为xlsx格式或内容不符标准，请检查并修改它!",
    "server.mam.application.used.terminal.profiles": "应用程序被终端配置文件使用，终端配置文件: {param}",
    "error.loading.role": "加载角色权限时发生错误",
    "certificate": "证书",
    "server.file.name.format.requirements": "文件名称只允许输入大小写字母、数字、点和下划线",
    "server.mdm.sn.not.exists": "设备不存在",
    "error.sms.not.enable":"没有已启用的短信网关配置",
    "server.mfm.boot.animation.name.exists": "开机动画名称已存在",
    "server.mfm.boot.picture.name.exists": "开机第一帧名称已存在",
    "server.mfm.wallpaper.name.exists": "壁纸名称已存在",

    "search.installed.application": "搜索已安装的应用程序",
    "select.application.to.uninstall.block": "请选择开启防卸载的应用程序",
    "select.application.to.cancel.uninstall.block": "请选择关闭防卸载的应用程序",
    "server.mrm.report.attribute.code.format.mismatch": "属性码格式不匹配，长度：1-50；格式：字母、数字、空格，不能以空格开头或结尾",
    "server.mrm.report.attribute.name.format.mismatch": "属性名称格式不匹配，长度：1-50；不能以空格开头或结尾",
    "server.mcm.reduced.time.cannot.be.greater.than.remaining.authorization": "减少的授权次数不能超过剩余的授权次数",
    "server.mcm.partner.remaining.time.less.than.customer.increase.times": "合作伙伴解除拆机告警授权剩余次数少于客户增加的次数",
    "server.mcm.tamper.authorization.already.exists.under.partner": "合作伙伴下已存在解除拆机告警分配授权",
    "server.mcm.tamper.authorization.already.exists.under.customer": "客户已存在解除拆机告警分配授权",
    "server.mcm.partner.allocate.times.is.empty": "合作伙伴不存在解除拆机告警授权次数",
    "server.mcm.authorization.policy.not.exists": "解除拆机告警授权不存在",
    "server.mcm.partner.allocate.time.less.than.customer.allocate.times": "合作伙伴解除拆机告警授权剩余次数少于客户分配的次数",
    "server.mcm.customer.not.bound.tamper.auth.policy": "客户没有绑定拆机告警授权策略",
    "server.mcm.partner.not.bound.tamper.auth.policy": "合作伙伴没有绑定拆机告警授权策略",
    "server.mcm.tamper.auth.times.used.up": "拆机授权策略没有可用次数",
    "server.mcm.fail.get.otp.code": "获取OTP口令失败，请联系管理员",
    "server.mcm.email.not.bound.otp": "拆机授权策略邮箱没有绑定OTP",
    "server.mcm.token.sn.invalid": "无效的令牌",
    "server.mcm.invalid.otp.code": "无效的OTP口令",
    "server.mcm.otp.temp.lock": "OTP临时锁定，请联系管理员",
    "server.mcm.otp.permanently.lock": "OTP永久锁定，请联系管理员",
    "server.mcm.verify.otp.code.exception": "验证OTP口令异常，请联系管理员",
    "server.mcm.send.email.fail": "发送邮件失败，请联系管理员",
    "server.mfm.upload.cer.file.format" : "请上传证书文件",
    "server.mcm.authorization.time.cannot.be.empty": "授权次数不能为空，请检查并修改",
    "server.mrm.report.export.too.large": "下载数据过多，已生成批量任务，任务ID:{param}",
    "server.mfm.boot.animation.picture.must.be.in.the.same.format": "开机动画图片的格式必须相同",
    "server.mfm.the.size.of.background.music.cannot.exceed.100kb": "背景音乐大小不能超过100kb",
    "server.mfm.failed.to.get.height.and.width.of.picture.when.making.boot.animation": "制作开机动画时，无法获取图片的高度和宽度。",
    "server.mfm.the.picture.resolution.does.not.match.model.version": "图片分辨率与型号版本不匹配",
    "server.mfm.the.picture.format.does.not.match.model.version": "图片格式与型号版本不匹配",
    "server.mfm.the.size.of.the.boot.animation.file.cannot.exceed.5m": "开机动画文件的大小不能超过5M",
    "server.mfm.background.music.playback.time.does.not.match.with.images.played.per.second": "背景音乐播放时间与每秒播放的图像不匹配",
    "server.mfm.there.is.an.exception.in.reading.background.music": "读取背景音乐出现异常",
    "server.mfm.please.check.whether.the.background.music.is.correct": "请检查背景音乐是否正确",
    "server.mfm.current.user.does.not.have.permission.to.add": "当前用户没有权限添加.",
    "server.mcm.role.attached.partner": "角色与此合作伙伴相关联",

    "server.partner.number.has.reached.upper.limit":"合作伙伴数量已达到上限",
    "server.accounts.number.has.reached.limit":"用户数量已达到上限",
    "server.merchant.accounts.number.has.reached.limit":"商户账户数量已达到上限",
    "server.application.number.has.reached.maximum.limit":"应用数量已达到上限",
    "server.firmware.number.has.reached.maximum.limit":"固件数量已达到上限",
    "server.tamper.number.has.reached.upper.limit":"解除拆机告警数量已达到上限",
    "server.ad.planner.not.alloted":"广告功能已禁用",
    "server.remote.control.device.not.alloted":"远程控制功能已禁用",
    "server.device.number.has.reached.maxinum.limit":"设备数量已达到上限",
    "server.transaction.parameters.number.has.reached.maxinum.limit":"交易参数数量已达到上限",
    "service.has.expired":"授权已过期",
    "server.configuration.error":"服务器配置错误",

    "server.license.file.already.exists":"授权文件已存在",
    "server.license.info.not.exists":"授权文件不存在",
    "server.mkm.device.no.upload.public.key":"设备未上传公钥",
    "server.msm.ui.settings.version.not.exists":"UI设置版本版本不存在,请检查并修改。",
    "server.mfm.file.name.length.invalid": "文件名长度不能超过50!",
    "server.common.name.already.exists": "报表名称已存在。",
    "server.customer.be.consistent":"广告版本所绑定的客户应与广告一致.",

    "server.common.file.name.format.mismatch": "文件名不能包含特殊字符#号和?号",
    "server.accounts.number.exceeds.auth.limit":"系统用户数量大于授权数量",
    "server.merchant.accounts.number.exceeds.auth.limit":"系统商户用户数量大于授权数量",
    "server.device.number.exceeds.auth.limit":"系统设备数量大于授权数量",
    "server.transaction.parameters.number.exceeds.auth.limit":"系统交易参数数量大于授权数量",
    "server.partner.number.exceeds.auth.limit":"系统合作伙伴数量大于授权数量",
    "server.tamper.number.exceeds.auth.limit":"系统解除告警次数大于授权数量",
    "server.firmware.number.exceeds.auth.limit":"系统固件数量大于授权数量",
    "server.application.number.exceeds.auth.limit":"系统应用数量大于授权数量",
    "server.common.apk.sign.fail": "apk签名失败",
    "server.json.layout.invalid":"JSON布局无效或包含空JSON（请填写内容）。请检查并修改它。",
    "server.storm.sms.is.enable": "短信设置已启用，无法删除",
    "service.storm.enable.sms.exist": "已经存在启用的短信",
    "server.common.version.exists.different.merchant":"存在不同商户下的数据，无法编辑",
    "server.firmware.edit.ascription": "存在不同级别的固件版本，无法编辑",
    "Authorization has expired":"授权已过期",
    "server.mdevm.accesskey.name.exists":"访问密钥名称已存在",

    "server.mcm.user.attached.with.customer":"用户与此客户相关联",
    "server.mcm.application.attached.with.customer":"应用程序与此客户相关联",
    "server.mcm.application.version.attached.with.customer":"应用程序版本与此客户相关联",
    "server.mcm.firmware.attached.with.customer":"固件与此客户相关联",
    "server.mcm.firmware.version.attached.with.customer":"固件版本与此客户相关联",
    "server.mcm.group.attached.with.customer":"组与客户相关联，请先删除组",
    "server.mcm.geo.fencing.attached.with.customer":"地理围栏与此客户相关联",
    "server.mcm.certificate.attached.with.customer":"证书与此客户相关联",
    "server.mcm.folder.attached.with.customer":"文件夹与此客户相关联",
    "server.mcm.file.attached.with.customer":"文件与此客户相关联",
    "server.mcm.advertisement.attached.with.customer":"广告计划与此客户相关联",
    "server.mcm.advertisement.version.attached.with.customer":"广告与此客户相关联",
    "server.mcm.ui.settings.attached.with.customer":"UI设置与此客户相关联",
    "server.mcm.templates.attached.with.customer":"交易参数与此客户相关联",
    "server.mcm.templates.version.attached.with.customer":"交易参数版本与此客户相关联",

    "server.mcm.user.attached.with.merchant":"用户与此商店相关联",
    "server.mcm.application.attached.with.merchant":"应用程序与此商店相关联",
    "server.mcm.application.version.attached.with.merchant":"应用程序版本与此商店相关联",
    "server.mcm.firmware.attached.with.merchant":"固件与此商店相关联",
    "server.mcm.firmware.version.attached.with.merchant":"固件版本与此商店相关联",
    "server.mcm.group.attached.with.merchant":"组与商户相关联，请先删除组",
    "server.mcm.geo.fencing.attached.with.merchant":"地理围栏与此商店相关联",
    "server.mcm.folder.attached.with.merchant":"文件夹与此商店相关联",
    "server.mcm.file.attached.with.merchant":"文件与此商店相关联",
    "server.mcm.advertisement.attached.with.merchant":"广告计划与此商店相关联",
    "server.mcm.advertisement.version.attached.with.merchant":"广告与此商店相关联",
    "server.mcm.ui.settings.attached.with.merchant":"UI设置与此商店相关联",
    "server.mcm.templates.attached.with.merchant":"交易参数与此商店相关联",
    "server.mcm.templates.version.attached.with.merchant":"交易参数版本与此商店相关联",
    "server.mcm.message.attached.with.partner": "消息与此合作伙伴相关联",
    "server.mcm.message.attached.with.customer": "消息与此客户相关联",
    "server.mcm.message.attached.with.merchant": "消息与此商店相关联",
    "server.mcm.profile.attached": "配置文件与此合作伙伴相关联",
    "server.msm.boot.animation.only.support.zip": "启动动画仅支持zip文件",
    "server.description.format.mismatch":"描述格式不匹配，长度为0-255",
    "error.device.no.application":"在设备上没有此应用程序",
    "server.model.version.file.may.have.been.tampered.with": "请检查数据或授权文件是否有效!",
    "server.mfm.firmware.name.extension": "固件仅支持zip和bin后缀文件!",
    "server.file.format.mismatch": "文件格式不匹配，请检查!",
    "user.avatar.not.exist": "用户头像不存在!",
    "server.extend.attribute.more.than.default.number": "设备扩展属性超过默认数量",
    "server.device.extend.attribute.name.exists": "设备扩展属性名称已存在",
    "server.attribute.type.string": "属性值必须为长度0-50的字符串，仅允许字母、数字及中间空格（首尾禁空）",
    "server.attribute.type.integer":"属性值应介于0-65535之间",
    "server.attribute.type.boolean": "属性值为布尔类型。请检查并修改",
    "server.common.expiration.time.greater.than.execution.time": "过期时间应大于执行时间",
    "server.not.devices.exists.in.group": "所选组不包含设备！",
    "auth.file.parsing.failed": "授权文件解析失败",
    "server.common.expiration.time.greater.than.current.time": "到期时间应大于当前时间",
    "server.mdm.log.capture.type.is.required": "日志捕获类型是必需的，不能为空",
    "error.device.not.app.in.dominant.state":"该设备没有处于霸屏状态的应用",
    "select.group.or.device.not.exists": "设备或者组不能为空",
    "server.group.unbind.device.already.bound.in.the.group": "请先解除组内已绑定的设备",
    "server.repository.attached.with.partner": "存储库与此合作伙伴关联",
    "server.repository.attached.with.customer": "存储库与此客户关联",
    "server.repository.attached.with.merchant": "存储库与此商户关联",
    "server.cloud.message.attached.with.partner": "云消息与此合作伙伴关联",
    "server.cloud.message.attached.with.customer": "云消息与此客户关联",
    "server.cloud.message.attached.with.merchant": "云消息与此商户关联",
    "server.mcm.email.format.mismatch": "电子邮件格式不匹配：最大长度：50；格式：电子邮件格式",
    "server.mmm.message.content.format.not.match": "选择HTML类型时，内容格式不匹配",
    "only.admin.can.perform.this.operation": "只有管理员和Operator角色可以执行此操作",
    "the.task.has.been.pushed": "任务已推送",
    "server.cloud.message.are.associated.with.this.repository":"云消息与此存储库关联，请先删除",
    "server.mam.error.occurred.generating.certificate": "生成证书时发生错误",
    "server.user.deletion.only.when.disabled": "用户只有在禁用状态下才可以被删除",
    "server.apk.file.size.max.size": "APK 文件大小不得超过 300MB",
    "server.alert.policy.attached.with.partner": "报警功能已被合作伙伴引用。请在删除合作伙伴帐户之前先解除关系。",
    "server.singed.certificate.files.do.not.match": "上传的签名证书文件不匹配",
    "server.transaction.parameter.version.exists.in.report": "交易参数版本存在于报表条件中，无法删除",
    "server.delete.device.key.fail": "删除设备失败",
    "server.firmware.file.in.use.cannot.be.deleted": "该固件文件正被计划任务使用，无法删除",
    "server.mdm.remove.tid.to.bind.or.unbind": "请清除所有与序列号相关的TID",
    "server.executed.scheduler.tasks.cannot.be.changed": "已执行的Scheduler Tasks不允许更改",
    "server.cloud.message.cannot.deleted": "在启用状态下，云消息无法被删除",
    "server.license.file.version.mismatch": "授权文件版本不匹配",
    "server.mrm.report.custom.report.limit.exceeded":"该合作伙伴可创建的自定义报表数量已达上限",
    "server.partner.network.config.exists":"合作伙伴代理设置已存在",
    "server.download.circuit.breaker.partner.already.exists":"partner禁止重复添加",
    "server.ecr.device.not.allow.capture.log.individually":"ECR 设备不允许单独抓取日志",
    "server.mam.exception.occurred.deleting.file": "删除文件时发生异常",
    "server.user.password.error": "密码错误 ，剩余错误重试次数：{param}",
    "server.storm.user.locked": "用户已被锁定，请在{param}分钟后重试",
    "server.storm.user.permanent.locked": "该用户已被永久锁定。请与管理员联系",
    "server.user.report.already.added":"用户账户已添加报表，需要删除该报表才能更改权限",
    "server.check.data.or.authorization.file.is.valid": "请检查导入的文件或授权文件是否有效",
    "service.partner.already.has.rules.in.place":"此partner已存在规则",
    "server.rule.detail.contains.duplicate.data": "规则详情包含重复数据",
    "server.user.type.not.support":"不支持的用户类型",
    "server.proxy.settings.attached.with.partner":  "代理配置与此合作伙伴关联",
    "server.report.attached.with.partner": "报表与此合作伙伴关联",
    "server.storm.merchant.user.access.denied": "用户无权访问STORM系统，请联系管理员",
    "server.download.circuit.breaker.param.invalid": "下载断路器参数无效",
    "server.mam.application.device.version.profile.model.version.not.consistent": "应用程序版本由终端配置文件使用，终端配置文件: {param}",
    "server.mdm.firmware.version.profile.model.version.not.consistent": "固件版本被终端配置文件使用，终端配置文件: {param}",
    "server.profile.firmware.not.exists": "固件不存在，请检查并修改。",
    "server.profile.firmware.version.not.exists": "固件版本不存在，请检查并修改。",
    "server.profile.app.version.not.exists": "应用版本不存在，请检查并修改。",
    "server.msm.system.param.version.not.exists": "系统参数版本不存在，请检查并修改。",
    "server.profile.system.param.not.accessible": "系统参数版本不可访问，请检查并修改。",
    "server.profile.firmware.not.accessible": "固件不可访问，请检查并修改。",
    "server.profile.app.not.accessible": "应用不可访问，请检查并修改。",
    "server.profile.system.version.mismatch": "系统参数版本不匹配，请检查并修改。",
    "server.profile.system.json.mismatch": "系统参数JSON布局不匹配，请检查并修改。",
    "server.profile.app.version.mismatch": "应用版本与应用不匹配，请检查并修改。",
    "server.profile.app.filename.mismatch": "应用文件名不匹配，请检查并修改。",
    "server.profile.app.version.code.mismatch": "应用版本号不匹配，请检查并修改。",
    "server.profile.app.package.name.mismatch": "应用包名不匹配，请检查并修改。",
    "server.profile.wallpaper.not.exists": "壁纸不存在，请检查并修改。",
    "server.profile.wallpaper.not.accessible": "壁纸不可访问，请检查并修改。",
    "server.profile.bootanimation.not.exists": "开机动画不存在，请检查并修改。",
    "server.profile.bootanimation.not.accessible": "开机动画不可访问，请检查并修改。",
    "server.profile.bootanimation.filename.mismatch": "开机动画文件名不匹配，请检查并修改。",
    "server.device.os.name.is.empty": "设备操作系统名称为空",
    "server.not.meet.the.upgrade.rule": "设备不满足升级规则",
    "server.device.model.version.not.match": "设备模型版本不匹配",
    "server.mkm.key.capture.no.have.use.device.created.keys": "已激活的设备已全部创建密钥",
    "server.gray.release.template.referenced.by.task": "模板已被灰度发布任务引用，无法删除，灰度任务: {param}",
    "server.dict.type.exists": "字典类型已存在",
    "server.dict.label.exists": "字典标签已存在"
}
